// NotFound404.jsx
import React from "react";
import { Link } from "react-router-dom";

const NotFound404 = () => {
  return (
    <div className="notfound-bg d-flex justify-content-center align-items-center vh-100">
      <div className="notfound-card text-center p-5">
        <div className="logo-wrap mb-3" aria-hidden="true">
          <img
            alt="404-img"
            src={require("assets/img/not-found.png")}
            className="notfound-page-logo img-fluid"
          />
        </div>

        <h1 className="oops-text mb-2">Oops!</h1>

        <h4 className="fw-bold mb-3">404 — Page Not Found</h4>

        <p className="text-muted mb-4">
          The requested URL was not found on this server.
        </p>

        {/* <Link to="/" className="btn btn-default px-4 py-2 rounded-pill">
          GO TO HOMEPAGE
        </Link> */}
      </div>
    </div>
  );
};

export default NotFound404;
